import {
  GET_SUBS_DATA,
  GET_SUBS_DATA_SUCCESS,
  GET_SUBS_DATA_FAIL,
  GET_ACTIVE_SUB_DATA,
  GET_ACTIVE_SUB_DATA_SUCCESS,
  GET_ACTIVE_SUB_DATA_FAIL,
  GET_SUBS_DRILL_DATA,
  GET_SUBS_DRILL_DATA_SUCCESS,
  GET_SUBS_DRILL_DATA_FAIL,
  GET_LOOKUP_DATA,
  GET_LOOKUP_DATA_SUCCESS,
  GET_LOOKUP_DATA_FAIL
} from '../constants/subs';

const initialState = {
  loading: false,
  loaded: false,
  data: null,
  error: null,
  drillLoaded: false,
  drillLoading: false,
  drillData: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SUBS_DATA:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: true,
          loaded: false,
          data: null,
          error: null
        }
      };
    case GET_SUBS_DATA_FAIL:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: false,
          loaded: false,
          data: null,
          error: action.error
        }
      };
    case GET_SUBS_DATA_SUCCESS:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: false,
          loaded: true,
          data: action.data,
          error: null
        }
      };
    case GET_ACTIVE_SUB_DATA:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: true,
          activeLoaded: false,
          error: null
        }
      };
    case GET_ACTIVE_SUB_DATA_FAIL:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: false,
          activeLoaded: false,
          error: action.error
        }
      };
    case GET_ACTIVE_SUB_DATA_SUCCESS:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: false,
          activeLoaded: true,
          activeSubs: action.activeSubs,
          error: null
        }
      };
    case GET_SUBS_DRILL_DATA:
      return {
        ...state,
        drillLoading: true,
        drillLoaded: false,
        drillData: null,
        error: null
      };
    case GET_SUBS_DRILL_DATA_SUCCESS:
      return {
        ...state,
        drillLoading: false,
        drillLoaded: true,
        drillData: action.data,
        error: null
      };
    case GET_SUBS_DRILL_DATA_FAIL:
      return {
        ...state,
        drillLoading: false,
        drillLoaded: false,
        drillData: null,
        error: action.error
      };
    case GET_LOOKUP_DATA:
      return {
        ...state,
        lookupData: null,
        error: null
      };
    case GET_LOOKUP_DATA_SUCCESS:
      return {
        ...state,
        lookupData: action.data,
        error: null
      };
    case GET_LOOKUP_DATA_FAIL:
      return {
        ...state,
        lookupData: null,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/subs.js